


















































































































































import Vue from "vue";
import { Form, Select } from "element-ui";
import { axios } from "../../plugins";

const roleOptions = [
  {
    label: "集群管理员,可以管理集群中所有资源",
    value: "CLUSTER_ADMIN"
  },
  {
    label: "集群运维,可以管理集群日常运营维护",
    value: "CLUSTER_OPERATOR"
  },
  {
    label: "集群中普通用户，在被邀请加入企业空间之前没有任何权限",
    value: "CLUSTER_REGULAR"
  }
];

const orginOptions = [
  {
    label: "平台原生用户",
    value: "NATIVE"
  },
  {
    label: "LDAP 用户",
    value: "LDAP"
  }
];

const basicRules = {
  userName: [{ type: "string", required: true, pattern: /^[a-zA-Z0-9_]+$/ }],
  email: [{ type: "email", required: true }],
  name: [{ type: "string", required: true }],
  role: [{ type: "string", required: true }],
  phone: [{ type: "string", pattern: /^1[3456789]\d{9}$/ }]
};
export default Vue.extend({
  name: "Edit",
  data() {
    return {
      dialog: false,
      isEdit: false,
      showPass: false,
      roleOptions,
      orginOptions,
      ruleForm: {
        userName: "",
        email: "",
        description: "",
        password: "",
        phone: "",
        roles: "",
        origin: "",
        name: "",
        id: ""
      }
    };
  },
  computed: {
    rules: function() {
      if (this.isEdit) {
        return basicRules;
      } else {
        return {
          ...basicRules,
          password: [
            {
              type: "string",
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,24}$/,
              required: true
            }
          ],
          origin: [{ type: "string", required: true }]
        };
      }
    }
  },
  methods: {
    // 下拉框 focus 事件
    formClick() {
      // 监听 dom click 事件
      document.removeEventListener("click", this.selectBlur);
      document.addEventListener("click", this.selectBlur);
    },
    selectBlur() {
      // 手动关闭下拉框 options
      (this.$refs.select as Select)?.blur();
      (this.$refs.select1 as Select)?.blur();
    },
    show(data?: any) {
      if (data) {
        // 编辑模式
        this.initData(data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
    },
    quit() {
      this.ruleForm = (this as any).$options.data().ruleForm;
      (this.$refs.ruleForm as Form).resetFields();
      this.dialog = false;
      this.showPass = false;
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    edit() {
      axios.put("/user", this.ruleForm).then(() => {
        this.$message.success("用户信息修改成功");
        this.quit();
        this.$emit("afterEdit");
      });
    },
    create() {
      axios.post("/user", this.ruleForm).then(() => {
        this.$message.success("用户创建成功");
        this.quit();
        this.$emit("afterEdit");
      });
    },
    initData(data: any) {
      for (const item in this.ruleForm) {
        if (Object.prototype.hasOwnProperty.call(this.ruleForm, item)) {
          if (item != "roles") (this.ruleForm as any)[item] = data[item];
          else {
            const roles = [];
            for (let i = 0; i < data.roles.length; ++i) {
              roles.push(data.roles[i].role);
            }
            (this.ruleForm as any)[item] = roles;
          }
        }
      }
    }
  }
});
